// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2B5zF","title":"ClientReferral_title__2cwRL","itemText":"ClientReferral_itemText__ZXe6K"};